
    import './styles.scoped.css';
    export default {
  "progress": "awsui_progress_11huc_3ulek_13",
  "result-state": "awsui_result-state_11huc_3ulek_27",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_11huc_3ulek_1",
  "root": "awsui_root_11huc_3ulek_49",
  "with-result-button": "awsui_with-result-button_11huc_3ulek_81",
  "result-text": "awsui_result-text_11huc_3ulek_85",
  "result-container-error": "awsui_result-container-error_11huc_3ulek_89",
  "result-container-success": "awsui_result-container-success_11huc_3ulek_89",
  "result-button": "awsui_result-button_11huc_3ulek_93",
  "word-wrap": "awsui_word-wrap_11huc_3ulek_99",
  "label-flash": "awsui_label-flash_11huc_3ulek_104",
  "label-key-value": "awsui_label-key-value_11huc_3ulek_108",
  "flash": "awsui_flash_11huc_3ulek_116",
  "progress-container": "awsui_progress-container_11huc_3ulek_120",
  "percentage-container": "awsui_percentage-container_11huc_3ulek_127",
  "percentage": "awsui_percentage_11huc_3ulek_127",
  "complete": "awsui_complete_11huc_3ulek_173",
  "progress-flash": "awsui_progress-flash_11huc_3ulek_186",
  "additional-info": "awsui_additional-info_11huc_3ulek_199"
};
  